import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores';

export default function HomePage() {
    const { isAuthenticated } = useAuthStore();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/chat', { replace: true });
        } else {
            navigate('/login', { replace: true });
        }
    }, [isAuthenticated, navigate]);

    // Show loading state while redirecting
    return (
        <div className='flex min-h-screen items-center justify-center bg-[var(--stan-bg-color)]'>
            <div className='text-center'>
                <div className='mx-auto h-8 w-8 animate-spin rounded-full border-b-2 border-blue-600' />
                <p className='mt-2 text-[var(--stan-text-primary-color)]'>Loading...</p>
            </div>
        </div>
    );
}
